export const SUCCESS = "success";
export const WARNING = "warning";
export const INFO = "info";
export const ERROR = "error";
